__webpack_require__.p = "/acquisition-posting-details-modal/system-email-templates/";